import { useAccount } from 'wagmi'
import { useTokenAllowance } from '~/hooks/useTokenAllowance'
import { useAllowanceTarget } from '~/state/dex/hooks'

export const useLimitOrderAllowance = (token: ERC20Token) => {
  const { address: account } = useAccount()
  const allowanceTarget = useAllowanceTarget()

  return useTokenAllowance(token, account, allowanceTarget)
}
